var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.446 18.463a.779.779 0 0 1-.788.768H5.89a.78.78 0 0 1-.788-.769V15h6.673c.648 0 1.176-.517 1.176-1.153V8.076c0-.636-.528-1.153-1.176-1.153H5.102V1.541A.78.78 0 0 1 5.89.769h7.061v5c0 .213.176.385.393.385h5.102v12.309zM1.176 14.23a.388.388 0 0 1-.391-.384V8.076c0-.212.176-.384.392-.384h10.598c.216 0 .391.172.391.384v5.771a.388.388 0 0 1-.391.384H1.177zm12.56-13.193 4.268 4.347h-4.268V1.038zm5.385 4.374-5.2-5.294A.396.396 0 0 0 13.64 0h-7.75c-.866 0-1.572.691-1.572 1.54v5.383h-3.14C.527 6.923 0 7.44 0 8.076v5.771C0 14.483.528 15 1.177 15h3.14v3.462c0 .848.706 1.538 1.573 1.538h11.768c.867 0 1.573-.69 1.573-1.537V5.679a.38.38 0 0 0-.11-.267z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.37ff9b82.svg";
export { ForwardRef as ReactComponent };